import appleLogo from "@assets/apple_logo.webp"
import googleLogo from "@assets/google_logo.webp"
import Button from "@components/Button"
import Input from "@components/Input"
import Layout from "@components/Layout"
import PasswordInput from "@components/PasswordInput"
import { useTranslation } from "react-i18next"
import { Form, Link, useActionData, useNavigation } from "react-router-dom"
import { SignInActionData } from "src/actions/signInAction"

export default function SignInPage() {
  const signInActionData = useActionData() as SignInActionData
  const navigation = useNavigation()
  const { t } = useTranslation()

  const isSubmitting = ["loading", "submitting"].includes(navigation.state)

  return (
    <Layout>
      <div className="flex h-full flex-col space-y-11">
        <div className="shrink-0 space-y-6 text-center">
          <h1 className="custom-heading">
            {t("pages.account.signIn.heading")}
          </h1>

          {signInActionData?.error && (
            <p className="custom-subheading-error">{signInActionData.error}</p>
          )}
        </div>

        <div className="flex grow flex-col justify-center">
          <Form className="space-y-7" method="post">
            <fieldset className="space-y-7" disabled={isSubmitting}>
              <Input
                name="email"
                placeholder={t("shared.email")}
                type="email"
              />

              <PasswordInput name="password" />

              <Link
                className="float-right mr-4 text-sm font-semibold text-gray-400 underline"
                to="/account/forgot-password"
              >
                {t("pages.account.signIn.forgotPassword")}
              </Link>
            </fieldset>

            <Button
              disabled={isSubmitting}
              type="submit"
              title={t("shared.signIn")}
            />
          </Form>
        </div>

        {/* TODO: Implement Apple and Google sign in */}
        {false && (
          <div className="flex grow flex-col justify-center space-y-7">
            <Form method="post">
              <input name="provider" type="hidden" value="apple" />

              <button
                className="custom-button-secondary"
                disabled={isSubmitting}
                type="submit"
              >
                <img src={appleLogo} alt="Apple logo" className="h-6 w-6" />

                {t("pages.account.signIn.signInWithApple")}
              </button>
            </Form>

            <Form method="post">
              <input name="provider" type="hidden" value="google" />

              <button
                className="custom-button-secondary"
                disabled={isSubmitting}
                type="submit"
              >
                <img src={googleLogo} alt="Google logo" className="h-6 w-6" />
                {t("pages.account.signIn.signInWithGoogle")}
              </button>
            </Form>
          </div>
        )}

        <div className="shrink-0 text-center">
          <Link className="text-lg font-semibold" to="/onboarding">
            {t("pages.account.signIn.signUp")}
          </Link>
        </div>
      </div>
    </Layout>
  )
}
